var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 116,
    viewBox: "0 0 114 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 113,
    height: 115,
    rx: 9.5,
    fill: "#F8F8F8",
    stroke: "#A9A9A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6668 34.6667H43.0002C41.7625 34.6667 40.5755 35.1584 39.7003 36.0336C38.8252 36.9088 38.3335 38.0957 38.3335 39.3334V76.6668C38.3335 77.9044 38.8252 79.0914 39.7003 79.9666C40.5755 80.8418 41.7625 81.3334 43.0002 81.3334H71.0002C72.2378 81.3334 73.4248 80.8418 74.3 79.9666C75.1752 79.0914 75.6668 77.9044 75.6668 76.6668V48.6667L61.6668 34.6667Z",
    stroke: "#717171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6665 34.6667V48.6667H75.6665",
    stroke: "#717171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 72V58",
    stroke: "#717171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65H64",
    stroke: "#717171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateBlank);
export default __webpack_public_path__ + "static/media/createBlank.759a1562d0bb177faf460b4e1b65c0d1.svg";
export { ForwardRef as ReactComponent };